import React from 'react';
import { GiftIcon } from 'lucide-react';
import { formatPrice } from '../data/config';
import { CheckItem } from './CheckItem';
type Group = {
  label: string;
  text: string;
};
type BonusCardProps = {
  number: string;
  title: string;
  subtitle: string;
  price: number;
  intro: string[];
  list?: string[];
  groups?: Group[];
  outro?: string[];
  finalLine: string;
  meta?: string;
  showReferencePrice: boolean;
};
export function BonusCard({
  number,
  title,
  subtitle,
  price,
  intro,
  list,
  groups,
  outro,
  finalLine,
  meta,
  showReferencePrice
}: BonusCardProps) {
  return <article className="rounded-md border-l-[5px] border-gold bg-white px-3.5 py-3 text-left md:px-4 md:py-3.5" data-id="element-11" data-mp="29ew2ra4wo08c">
      <h3 className="flex items-start gap-2 font-heading text-[14px] font-extrabold uppercase leading-tight text-navy md:text-[15px]" data-id="element-12" data-mp="2e6w7dfvx7hb9">
        <GiftIcon className="mt-px h-4 w-4 shrink-0 text-goldDark" strokeWidth={2.5} aria-hidden data-id="element-13" data-mp="1hlvnxx4ib6nf" />
        <span data-id="element-14" data-mp="1lngvd2y9usq8">
          Bonus {number} — {title}
        </span>
      </h3>
      <p className="mt-1 font-heading text-[12px] font-bold leading-snug text-brand md:text-[13px]" data-id="element-15" data-mp="1x1lf3182n1oo">{subtitle}</p>
      <p className="mt-0.5 flex flex-wrap items-center gap-2 font-heading text-[11px] font-extrabold uppercase md:text-[12px]" data-id="element-16" data-mp="1s3tme4zlrbjf">
        {showReferencePrice && <s className="font-semibold text-ink/60" data-id="element-17" data-mp="1idqj9byroh7d">{formatPrice(price)}</s>}
        <span className="text-check" data-id="element-18" data-mp="1de5o7cmpwszx">Free with your purchase</span>
      </p>
      <div className="mt-1.5 space-y-1 text-[14px] leading-[1.4] text-ink md:text-[15px]" data-id="element-19" data-mp="1dc187wbjo3ja">
        {intro.map(p => <p key={p} data-id="element-20" data-mp="14dfvihsr7iqf">{p}</p>)}
      </div>
      {list && <ul className="mt-1.5 space-y-0.5 text-[14px] leading-[1.4] text-ink md:text-[15px]" data-id="element-21" data-mp="14dpmo8pjbvxp">
          {list.map(item => <CheckItem key={item} data-id="element-22" data-mp="2yrgqgrl6nll8">{item}</CheckItem>)}
        </ul>}
      {groups && <dl className="mt-2 space-y-1.5 text-[14px] leading-[1.4] md:text-[15px]" data-id="element-23" data-mp="2tsdudwn6kppe">
          {groups.map(g => <div key={g.label} data-id="element-24" data-mp="s2oi1rmxh3c6">
              <dt className="font-heading text-[12px] font-extrabold uppercase text-navy md:text-[13px]" data-id="element-25" data-mp="s1n6zn5wwgug">{g.label}</dt>
              <dd className="text-ink" data-id="element-26" data-mp="ww16o1rlxa4x">{g.text}</dd>
            </div>)}
        </dl>}
      {outro && <div className="mt-1.5 space-y-1 text-[14px] leading-[1.4] text-ink md:text-[15px]" data-id="element-27" data-mp="n44uxnwllli8">
          {outro.map(p => <p key={p} data-id="element-28" data-mp="1at65phswl8qo">{p}</p>)}
        </div>}
      <p className="mt-2 font-heading text-[12px] font-extrabold uppercase leading-tight text-goldDark md:text-[13px]" data-id="element-29" data-mp="1arv51qur8h3s">
        {finalLine}
      </p>
      {meta && <p className="mt-1 text-[12px] font-semibold text-ink/70 md:text-[13px]" data-id="element-30" data-mp="10uqg5j9iy7ja">{meta}</p>}
    </article>;
}